<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                     <div class="d-flex justify-end">
                         <div class="d-none d-sm-block">
                             <Link :href="route('paymentRequests.manage')">
                                 <v-btn-input-compact text="Make Request" class="table-action">
                                     <template #prepend>
                                         <mdi-icon>add</mdi-icon>
                                     </template>
                                 </v-btn-input-compact>
                             </Link>
                         </div>
                         <div class="d-sm-none">
                             <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                 <mdi-icon :size="tableCard.actionMenu.btn.iconSize">{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                 <v-menu activator="parent" class="tiny-dropdown">
                                     <v-list>
                                         <Link class="v-list-item-n-link" :href="route('paymentRequests.manage')">
                                             <v-list-item title="Make Request" value="create_payment_request">
                                                 <template #prepend>
                                                     <mdi-icon>add</mdi-icon>
                                                 </template>
                                             </v-list-item>
                                         </Link>
                                     </v-list>
                                 </v-menu>
                             </v-btn-icon>
                         </div>
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                         <template v-slot:[`item.payment_method`]="{ item }:{item: PaymentRequest}" key="item.payment_method">
                             <div class="fw-medium">{{ item.payment_method_preview?.name }}</div>
                             <div class="fs-n5 font-italic" v-if="item.payment_method == 'crypto' && item.additional_data?.coin">{{ item.additional_data?.coin }}</div>
                         </template>
                         <template v-slot:[`item.completed`]="{ item }:{item: PaymentRequest}" key="item.completed">
                             <div class="text-center">
                                <mdi-icon class="text-success" v-if="item.completed">check</mdi-icon>
                                <mdi-icon class="text-danger" v-else>close</mdi-icon>
                             </div>
                         </template>
                         <template v-slot:[`item.amount`]="{ item }:{item: PaymentRequest}" key="item.amount">
                             <div class="text-no-wrap">
                                {{
                                    helpers.moneyFormatNew(item.amount ?? 0)
                                }}
                            </div>
                         </template>
                         <template v-slot:[`item.action`]="{ item }:{item: PaymentRequest}" key="item.action">
                             <div>
                                 <div class="d-none d-md-block">
                                     <div class="d-flex justify-center">
                                         <v-tooltip text="Edit" v-if="!item.completed">
                                             <template v-slot:activator="{ props }">
                                                 <Link :href="route('paymentRequests.manage', item.id)" v-bind="props">
                                                     <v-btn-icon-text color="primary">
                                                         <mdi-icon>edit_square</mdi-icon>
                                                     </v-btn-icon-text>
                                                 </Link>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Cancel" v-if="!item.completed">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="danger" v-bind="props" @click.prevent="dialogDeleteForm_Confirm(item)">
                                                    <mdi-icon>delete</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                     </div>
                                 </div>
                                 <div class="d-md-none">
                                     <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain" v-if="!item.completed">
                                         <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                         <v-menu activator="parent" class="tiny-dropdown">
                                             <v-list min-width="120px" >
                                                 <Link class="v-list-item-n-link" :href="route('paymentRequests.manage', item.id)" v-if="!item.completed">
                                                     <v-list-item title="Edit" value="edit_paymentRequests">
                                                         <template #prepend>
                                                             <mdi-icon>edit_square</mdi-icon>
                                                         </template>
                                                     </v-list-item>
                                                 </Link>
                                                <v-list-item title="Cancel" value="sent_document" v-if="!item.completed" @click.prevent="dialogDeleteForm_Confirm(item)">
                                                    <template #prepend>
                                                        <mdi-icon>delete</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                             </v-list>
                                         </v-menu>
                                     </v-btn-icon>
                                 </div>
                             </div>
                             
                         </template>
                     </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>
         
         <v-dialog v-model="dialogDeleteForm.show" width="auto" @afterLeave="dialogDeleteForm_Close">
            <v-card max-width="100%" width="500">
                <v-card-title>Cancel Request</v-card-title>
                <v-card-subtitle>Are you sure you want to cancel this Request?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="dialogDeleteForm.errors.custom_error" class="text-error">{{ dialogDeleteForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="No"
                        color="btn-secondary"
                        @click="dialogDeleteForm_Close"
                    ></v-btn>
                    <v-btn
                        :disabled="dialogDeleteForm.processing"
                        :loading="dialogDeleteForm.processing"
                        @click="dialogDeleteForm_Submit"
                        color="error"
                        text="Yes"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { PaymentRequest } from '@/Types/Models/payment-request';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import helpers from '@/Plugins/helpers';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: TableResponse<PaymentRequest>;
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Payment Requests';
    const datatable = useDatatable<PaymentRequest>(route('paymentRequests.index'), page.props.data.table);
    console.log(datatable.request.length)

    const tableCard = useTableCard();
    
    const dialogDeleteForm = useForm<{
        show: boolean,
        item: PaymentRequest | null,
        custom_error: string,
    }>({
        show: false,
        item: null,
        custom_error: '',
    });
    const dialogDeleteForm_Confirm = (item: PaymentRequest) => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
        dialogDeleteForm.item = item;
        dialogDeleteForm.show = true;
    }
    const dialogDeleteForm_Close = () => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
    }
    const dialogDeleteForm_Submit = () => {
        dialogDeleteForm.transform((data) => ({
            custom_error: data.custom_error
        })).delete(route('paymentRequests.delete', dialogDeleteForm.item?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                dialogDeleteForm_Close();
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Payment request is removed');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    }
 </script>